// src/test/IPTracker.js
import React, { useEffect, useState } from "react";

console.log("IPTracker component rendered");

const IPTracker = () => {
  // Local state to hold IP and loading status
  const [visitorData, setVisitorData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cloud Run URL
    const API_BASE = "https://portfolio-backend-401829555967.us-west1.run.app";

    // Call backend endpoint to get visitor info (IP, etc.)
    const fetchVisitorData = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/v1/webdata`);
        //const response = await fetch("http://localhost:8000/api/v1/webdata/visitor");
        console.log("Response status:", response.status);  // <-- check status
        const data = await response.json();
        console.log("Visitor data:", data);               // <-- check data
        setVisitorData(data);
      } catch (error) {
        console.error("Error fetching visitor data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitorData();
  }, []);

  if (loading) return <p>Loading visitor data...</p>;

  return (
    <div style={{ padding: "50px" }}>
      <h2>Visitor Info (MVP)</h2>
      {visitorData ? (
        <>
          <p><strong>Your IP:</strong> {visitorData.visitor_id}</p>
          <p><strong>Timestamp:</strong> {visitorData.timestamp}</p>
        </>
      ) : (
        <p>No data available</p>
      )}
      <h2>Testing out APi</h2>
    </div>
  );
};

export default IPTracker;
